import Ably from "ably";
import axiosInstance from "../app/axiosInstance";

export function createAblyRealtime(options = {}) {
  return new Ably.Realtime({
    authCallback: (_tokenParams, callback) => {
      axiosInstance
        .post("/ably/token")
        .then((response) => {
          callback(null, response.data);
        })
        .catch((error) => {
          callback(error, null);
        });
    },
    ...options,
  });
}
